import React from 'react';
import { EmptyAddress } from '../styles/locationAddress.styles';

const NoAddress = ({ secondary }) => {
  return (
    <EmptyAddress noAddress secondary={secondary}>
      Address Not Found
    </EmptyAddress>
  );
};

export default NoAddress;
